<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form v-on:submit.prevent="login()">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">
                  Veuillez vous identifier
                </h3>
              </div>
              <div>
                <fg-input label="Identifiant"
                          placeholder="Votre email"
                          type="email"
                          v-model="model.email">

                </fg-input>
                <fg-input label="Mot de passe"
                          type="password"
                          placeholder="Votre mot de passe"
                          v-model="model.password">
                </fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-info btn-round btn-wd ">
                  Valider
                </button>
                <br>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import { FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: true,
          fetchUser: true
        }
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login () {
        var redirect = this.$auth.redirect()
        this.$auth.login({
          body: this.model, // Vue-resource
          data: {
            email: this.model.email,
            password: this.model.password
          }, // Axios
          rememberMe: this.model.rememberMe,
          redirect: {name: redirect ? redirect.from.name : 'Overview'},
          fetchUser: this.model.fetchUser,
          success (res) {
            this.$auth.user(res.data.results)
          },
          error (res) {
            this.error = res.data
          }
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
